<template>
	<div class="c-tips"><slot></slot></div>
</template>

<script>
	export default {
		name: 'cTips'
	}
</script>

<style lang="stylus" scoped>
	.c-tips {
		z-index: 11;
		position: sticky;
		top: 0;
		padding: 10px 20px;
		line-height: 16px;
		font-size: 12px;
		color: #FF5555;
		background: #FFF9F9;
	}
</style>